import { Inject } from '@odinjs/odin';

import { PanelAPI, RepeaterAPI, TextAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { isEmptyArrayOrObject, isEmptyOrBlankString } from '@philips-emr/tws-utils';

import BaseController from '../BaseController';

@Controller({ fragment: 'solicitacao-exclusao-feedback' })
export default class SolicitacaoExclusaoFeedbackController extends BaseController {

  @Inject('text-ds_mensagem_web')
  private dsMensagemWeb: TextAPI;

  @Inject('repeater-protocolos')
  private protocolos: RepeaterAPI;

  @Inject('panel-orientacao')
  private orientacaoPanel: PanelAPI;

  @Inject('panel-ds_mensagem_web')
  private mensagemWebPanel: PanelAPI;

  @Inject('panel-protocolos')
  private protocoloPanel: PanelAPI;

  @OnMount({ target: 'layout-solicitacao-exclusao-feedback' })
  public onMountForms(): void {
    const ieLiberarRescisao = this.context.get('ieLiberarRescisao') as string;
    const dsMensagemWeb = this.context.get('dsMensagemWeb') as string;
    const protocolos = this.context.get('protocolos') as Record<string, Value>[];

    if (isEmptyArrayOrObject(protocolos)) {
      this.protocoloPanel.setVisible(false);
    } else {
      this.protocolos.setData(protocolos);
    }

    if (isEmptyOrBlankString(dsMensagemWeb)) {
      this.mensagemWebPanel.setVisible(false);
    } else {
      this.dsMensagemWeb.setValue(dsMensagemWeb);
    }

    if (ieLiberarRescisao === 'S') {
      this.orientacaoPanel.setVisible(false);
    }
  }

}
